import { Navbar } from "../components/portfolio/Navbar";
import { Hero } from "../components/portfolio/Hero";
import { About } from "../components/portfolio/About";
import { Experience } from "../components/portfolio/Experience";
import { Skills } from "../components/portfolio/Skills";
import { Education } from "../components/portfolio/Education";
import { Contact } from "../components/portfolio/Contact";
import { Footer } from "../components/portfolio/Footer";
import { useReveal } from "../hooks/useReveal";

export default function Portfolio() {
  useReveal();
  return (
    <div data-testid="portfolio-page" className="bg-paper text-ink min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Experience />
        <Skills />
        <Education />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
